import React from 'react'
import styled from '@emotion/styled'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ArticleCard } from 'experiences/learn/articles/ArticleCard'
import { EmptyState } from '../DashboardRoot/cards/FavoriteArticles/EmptyState'
import { CardStyle } from 'experiences/dashboard/DashboardRoot/cards'
import { useFavorites } from 'stores/Favorites'
import { buildArticleSummaryDataWrapper } from 'services/ContentfulService/hooks/articles'
import { DataWrapper } from 'components/patterns/suspense/internals/types'
import { Favorite } from 'generated/api'
import { BlockComponent } from 'lib'
import { LoadingBoundary } from 'components/patterns/suspense/Suspense'
import { ArticleGridAsync } from 'experiences/learn/articles/ArticleGrid'

interface Props {
	articles: Array<DataWrapper<ArticleSummary>>
}
const ReadingListView: BlockComponent<Props> = ({ articles }) => {
	return (
		<>
			<FavoriteArticlesWrapper>
				{articles && articles.length > 0 && <ArticleGridAsync articles={articles} mode="standard" />}
				<CardWithMargin>
					<EmptyState />
				</CardWithMargin>
			</FavoriteArticlesWrapper>
		</>
	)
}

interface ContainerProps {
	favoritesData: DataWrapper<Array<Favorite>>
}
const Container: BlockComponent<ContainerProps> = ({ favoritesData }) => {
	const favorites = favoritesData.read()
	const articles = favorites.map(favorite => buildArticleSummaryDataWrapper(favorite.favoriteId))
	return <ReadingListView articles={articles} />
}

export const ReadingList = () => {
	const [favorites] = useFavorites()
	return (
		<MinHeight>
			<Title>Reading List</Title>
			<LoadingBoundary fallback={<ArticleCard mode={'standard'} pending={true} />}>
				<Container favoritesData={favorites} />{' '}
			</LoadingBoundary>
		</MinHeight>
	)
}

const Title = styled.h2`
	margin-bottom: 32px;
`

const FavoriteArticlesWrapper = styled.div`
	min-height: 317px;
`
const MinHeight = styled.div`
	min-height: 80vh;
`
const CardWithMargin = styled.div`
	${CardStyle};
	margin-top: 32px;
`
